export default __webpack_public_path__ + "static/media/facebook.149de96e.png";